const stylesASAP = {
  mainContainer: {
    backgroundColor: "#e6e6fa",
    height: "100%",
  },
  spinner: {
    backgroundColor: "#e6e6fa",
    color: "#65a0ff",
  },
  fullwidth: {
    width: "100%",
    color: "#65a0ff",
  },
  itemName: {
    color: "#65a0ff",
    fontSize: 30,
  },
  itemName2: {
    color: "#FFFFFF",
    fontSize: 30,
  },
  clientName: {
    fontSize: 25,
  },
  itemButton: {
    backgroundColor: "#65a0ff",
    color: "#ffffff",
    width: "37%",
    height: "20%",
  },
  button: {
    backgroundColor: "#65a0ff",
    borderColor: "#65a0ff",
  },
  displayDoc: {
    display: "none",
  },
  loginCard: {
    paddingTop: "5%",
    paddingBottom: "5%",
    paddingRight: "30%",
    paddingLeft: "30%",
  },
  fixedPosition: {
    position: "fixed",
    top: 200,
    left: 0,
  },
  unfixedPosition: {
    overflowY: "scroll",
    paddingTop: 100,
  },
  wideButton: {
    backgroundColor: "#65a0ff",
    borderColor: "#65a0ff",
    color: "#ffffff",
    width: 250,
  },
  soButton: {
    backgroundColor: "#65a0ff",
    borderColor: "#65a0ff",
    width: 230,
    marginLeft: 20,
    marginTop: 5,
    color: "#ffffff",
  },
  pressedTab: {
    backgroundColor: "#65a0ff",
    color: "#ffffff",
  },
  unpressedTab: {
    backgroundColor: "#e6f9ff",
  },
  syncButton: {
    backgroundColor: "#65a0ff",
    borderColor: "#65a0ff",
    color: "#ffffff",
    width: 200,
    marginLeft: 550,
    marginBottom: 10,
  },
  mainBackgroundColor: {
    backgroundColor: "#e6e6fa",
  },
  checkbox: {
    color: "#65a0ff",
  },
  cardfirsthalf: {
    backgroundColor: "#e6f9ff",
  },
  cardsecondhalf: {
    backgroundColor: "#ffffff",
  },
  cardsecondhalfDelivery: {
    backgroundColor: "#ffffff",
  },
  fadedText: {
    color: "#5B869A",
  },
  itemSectionCard: {
    backgroundColor: "#e6f9ff",
  },
  image: {
    width: "9%",
    height: "1%",
    margin: 0,
    padding: 0,
  },
  image1: {
    width: "75%",
    height: "75%",
    margin: 0,
    padding: 0,
  },
  image2: {
    width: "20%",
    height: "10%",
    margin: 0,
    padding: 0,
  },
  imageGrid: {
    width: "70%",
    height: "70%",
    margin: 0,
    padding: 0,
  },
  itemTitle: {
    color: "#5B869A",
    marginBottom: 0,
  },
  floatRight: {
    float: "right",
    textAlign: "right",
  },
  saveButton: {
    backgroundColor: "#65a0ff",
    borderColor: "#65a0ff",
    color: "#ffffff",
    width: 150,
  },
  inputWidth: {
    width: 200,
  },
  inputWidthDiscount: {
    width: 400,
  },
  clientInputWidth: {
    width: 400,
    marginLeft: "30%",
  },
  clientMargin: {
    marginLeft: "40%",
  },
  selectWidth: {
    width: 150,
  },
  marginTitle: {
    marginTop: 10,
  },
  marginSelect: {
    marginTop: 60,
  },
  statementButton: {
    backgroundColor: "#65a0ff",
    borderColor: "#65a0ff",
    color: "#ffffff",
    marginLeft: 25,
  },
  deleteButtonAlert: {
    marginRight: 40,
  },
  ContainerBot: {
    marginright: 10,
    paddingLeft: 2,
  },
  mr: {
    marginRight: 40,
    paddingright: -25,
  },
  mt: {
    width: "54%",
    paddingLeft: -500,
  },
  cancelButtonAlert: {
    marginRight: 0,
    paddingBottom: 50,
  },
  sync: {
    marginLeft: 170,
  },
  synct: {
    marginLeft: 200,
  },
  deleteIcon: {
    paddingleft: 30,
    marginRight: 0,
    width: 100,
    height: 100,
  },
  paymentt: {
    paddingLeft: 600,
    marginTop: -50,
  },
  hr: {
    backgroundColor: "black",
  },
  title: {
    color: "white",
    fontSize: "12px",
  },
  printtitle: {
    fontSize: "13px",
  },
  printfont: {
    fontSize: "11px",
    marginLeft: "2px", // 4px top and bottom, 0 left and right
  },
  margin: {
    marginBottom: '10px',  // Adjust this value to decrease the space
  },
  printSignature: {
    width: "100px", // or any value you prefer
    height: "auto", // Keeps the aspect ratio of the image
    // other styles you might already have
  },

  saveButtont: {
    backgroundColor: "#65a0ff",
    borderColor: "#65a0ff",
    color: "#ffffff",
    width: 150,
    marginTop: -50,
  },
  reportClientInput: {
    width: 300,
  },
  reportClientInputRequired: {
    width: 300,
    borderColor: "red",
  },
  wideButton: {
    backgroundColor: "#65a0ff",
    borderColor: "#65a0ff",
    color: "#ffffff",
    width: 150,
  },
  mainBackgroundColor: {
    backgroundColor: "#e6e6fa",
    flex: 1,
  },
  mainBackgroundColor1: {
    backgroundColor: "#f5f5f5",
    flex: 1,
  },
  cardBackgroundColor: {
    backgroundColor: "#ffffff",
    marginTop: 0,
  },
  visitTitle: {
    marginTop: 20,
  },
  fa: {
    marginRight: 3,
    paddingLeft: 3,
  },
  delete: {
    marginBottom: 100,
  },
  iconsdelete: {
    color: "#ff0000",
    marginLeft: 400,
    width: 100,
    height: 25,
    marginBottom: 25,
  },
  iconsadd: {
    color: "#00Bfff",
    marginLeft: 398,
    width: 100,
    height: 25,
    marginBottom: 25,
  },
  iconsinfo: {
    color: "#ffa500",
    width: 50,
    height: 20,
  },
  iconsedit: {
    color: "#808080",
    width: 50,
    height: 20,
  },
  iconsPeople: {
    marginLeft: "25%",
  },
  sty: {
    width: "fitcontent",
  },
  deleteButtonAlert: {
    width: 100,
    marginRight: 10,
  },
  cancelButtonAlert: {
    marginRight: 10,
  },
  changeUser: {
    fontsize: 14,
  },
  spinner: {
    backgroundColor: "#e6e6fa",
    color: "#65a0ff",
  },
  mainContainer: {
    backgroundColor: "#e6e6fa",
    height: "100%",
  },
  clientDetailCard: {
    backgroundColor: "#ffffff",
    marginBottom: 0,
  },
  addclient: {
    color: "#00Bfff",
  },
  rightDirection: {
    float: "right",
    textAlign: "right",
    color: "#00Bfff",
    height: 50,
    width: 50,
  },
  wideButton: {
    backgroundColor: "#65a0ff",
    borderColor: "#65a0ff",
    color: "#ffffff",
    width: 150,
  },
  arrow: {
    marginLeft: 250,
    width: 100,
    height: 22,
    marginBottom: 50,
    marginTop: 40,
  },
  reportsTitle: {
    marginLeft: "15%",
  },
  cardBackgroundColor: {
    backgroundColor: "#ffffff",
  },
  reportInputWidth: {
    width: 500,
    maxWidth: "100%",
  },
  reportType: {
    fontWeight: "bold",
    width: 500,
    maxWidth: "100%",
  },
  reportTypeInput: {
    width: 200,
  },
  wideButton: {
    backgroundColor: "#65a0ff",
    borderColor: "#65a0ff",
    color: "#ffffff",
    width: 150,
  },
  reportDate: {
    marginBottom: 0,
  },
  reportTableItem: {
    color: "#65a0ff",
  },
  reportTableRow: {
    marginRight: 0,
    borderWidth: "1px",
    borderStyle: "Solid",
  },
  spinner: {
    backgroundColor: "#e6e6fa",
    color: "#65a0ff",
  },
  reportTableHeader: {
    backgroundColor: " #FFFFFF",
    color: "#D3D3D3",
    marginTop: 50,
    marginLeft: 5,
    marginRight: 50,
  },
  total: {
    marginTop: 25,
    marginLeft: 900,
    color: "#65a0ff",
  },
  type: {
    marginRight: 5,

    marginLeft: 10,
  },
  above: {
    backgroundColor: "#e6e6fa",
    height: "100%",
    marginBottom: -15,
  },
  date: {
    marginLeft: 0,
  },
  reportcolor: {
    height: "100%",
    width: "100%",
  },
  reportselect: {
    width: 500,
    maxWidth: "100%",
    height: 52,
  },
  reportInputWidth: {
    width: 215,
    maxWidth: "100%",
  },
  reportclient: {
    width: 440,
    marginLeft: 200,
  },
  reportlable: {
    width: 440,
  },
  displayDoc: {
    display: "none",
  },
  isgrid: {
    height: 40,
    weight: 80,
    margin: 2,
  },
  isgridClicked: {
    height: 40,
    weight: 80,
    margin: 2,
    backgroundColor: "#65a0ff",
    color: "white",
  },
  floatRight: {
    float: "right",
    textAlign: "right",
  },
  dateInOut: {
    backgroundColor: "#65a0ff",
    borderColor: "#65a0ff",
    color: "#ffffff",
    width: 250,
  },
  amountToPay: {
    width: 100,
  },
  disable: {
    pointerEvents: "none",
  },
  amountToPayDisable: {
    width: 100,
    pointerEvents: "none",
  },
  addButton: {
    textAlign: "center",
  },
  signature: {
    width: 200,
    height: 200,
    borderWidth: "1px",
    borderStyle: "Solid",
  },
  clearButton: {
    backgroundColor: "#65a0ff",
    borderColor: "#65a0ff",
    color: "#ffffff",
    width: 150,
    marginRight: 30,
  },
  disabledStyle: {
    pointerEvents: "none",
    backgroundColor: "#DEDEDE",
  },
  enabledStyle: {
    backgroundColor: "#ffffff",
  },
  wideButtonRequired: {
    borderColor: "#FF0000",
  },
  overflow: {
    whiteSpace: "pre-wrap",
    overflowWrap: "break-word",
  },
  wideButtonPreview: {
    backgroundColor: "#65a0ff",
    borderColor: "#65a0ff",
    color: "#ffffff",
    width: 150,
    marginRight: 30,
  },
  iconhome: {
    color: "#808080",
    width: 100,
    height: 50,
  },
  input: {
    width: 100,
  },
  code: {
    color: "#FFAE42",
  },
};
export default stylesASAP;
